module.exports = __webpack_public_path__ + "img/logo.593e833b.svg";